import React from 'react';
import ProductGridView from '../product-view/product-grid-view';
import { Helmet } from 'react-helmet';
import Spinner from '../utils/spinner/full-page-spinner';

function Home() {
  // Load configurations from environment variables
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const homepageCollection = process.env.REACT_APP_HOMEPAGE_COLLECTION;

  return (
    <div className="main home demo2-cls">
      <Helmet>
        <title>{companyName} - Home</title>
      </Helmet>
      <div className="page-content">
        <div className="container">
          {/* Render Product Grid View */}
          <ProductGridView 
            collectionSlug={{ "collectionSlug": `${homepageCollection}` }} 
            loading={false} 
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
